<div class="headline">
  <span class="mat-h1 m0">Funktionale Grammatik</span>
  @if (authService.isLoggedIn() && (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID')) {
    <span class="editing-group">
      @if (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID') {
        <button (click)="toggleSelectMode()" [attr.aria-pressed]="selectMode"
                aria-label="Einträge für Sammelmappen auswählen"
                class="header-buttons" color="primary" mat-flat-button>
          <mat-icon>{{ selectMode ? 'close' : 'create_new_folder' }}</mat-icon>
          <mat-label class="home-new-word-bt-text">{{ selectMode ? 'Auswahl beenden' : 'Sammelmappe' }}</mat-label>
        </button>
      }
      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="openNewCategoryDialog()"
          aria-label="Button to add a new category" class="header-buttons"
          color="primary" mat-flat-button>
          <mat-icon>add</mat-icon>
          <mat-label class="home-new-word-bt-text"> <span class="plain-text-new">Neue</span> Thema</mat-label>
        </button>
      }
      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="openNewEntryDialog()"
          aria-label="Button to add a new example"
          class="header-buttons"
          color="primary" mat-flat-button>
          <mat-icon>add</mat-icon>
          <mat-label class="home-new-word-bt-text"> <span class="plain-text-new">Neues</span> Beispiel</mat-label>
        </button>
      }
      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="toggleEditingTools(true)"
          aria-label="Button to disable editing"
          class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>remove_red_eye</mat-icon>
          <mat-label class="home-new-word-bt-text"> Ansicht</mat-label>
        </button>
      }
      @if ((displayEditingTools === false) && (authService.getUserRole() === 'ROLE_ADMIN')) {
        <button (click)="toggleEditingTools(true)"
          aria-label="Button to enable editing"
          class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>edit</mat-icon>
          <mat-label class="home-new-word-bt-text"> Bearbeiten</mat-label>
        </button>
      }
    </span>
  }

</div>
<hr>
  <div class="main-content-wrapper" style="margin: 0.8rem">
    <app-category-tree [displayEditingTools]="displayEditingTools" [isAdmin]="isAdmin" [service]="funcGrammarService" [reloadRootsTrigger]=reloadRootsTrigger [categoryId]="categoryId"
    [resetCategoryControl]="resetCategoryControl" [title]="'Systematik'" (reloadSearch)="handleChildSearch($event)" class="tree-content"></app-category-tree>
    <div class="table-content">
      <div class="custom-scrollbar mat-elevation" style="overflow-x: auto; background-color:white">
        <app-search-bar [showDetailedSearch]=false [resetTrigger]="resetSearchTrigger" [initialQuery]="initialSearchQuery" (search)="handleSearch($event)" (resetFilter)="handleResetFilter()"></app-search-bar>
        <app-table [displayedColumns]="displayedColumns" [isAuthorized]="isAuthorized" [searchTrigger]="searchTrigger"
        [selectedCategory]="categoryControl" [selectable]="selectMode" [service]="funcGrammarService"></app-table>
      </div>
    </div>
  </div>
